import { Box, Button, Text, Heading, useBreakpointValue } from "@chakra-ui/react";
import { sendTrackingEvent } from "../utils/gtm";

interface Props {
  setIsNeedHelpModalOpen: (value: boolean) => void;
  onBookSlot: (program: string) => void;
}

const NeedHelpModalContent = ({ setIsNeedHelpModalOpen, onBookSlot }: Props) => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  return (
    <Box mt={"24px"}>
      <Heading as="h6" textAlign={"center"}>
        Choose the program you want to book a slot for
      </Heading>
      <Box mt={"24px"} display={"grid"} gridGap={"16px"}>
        {["cap", "one"].map((program) => (
          <Box
            cursor={"pointer"}
            border="1px solid #CCCCCC"
            p={"8px"}
            key={program}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
            borderRadius={"8px"}
            onClick={() => {
              if (program === "cap") {
                const eventName = `dash_speek_to_team_book_slot_cap`;
                sendTrackingEvent({ event: eventName, eventLabel: location.pathname });
              } else {
                const eventName = `dash_speek_to_team_book_slot_masai`;
                sendTrackingEvent({ event: eventName, eventLabel: location.pathname });
              }
              setIsNeedHelpModalOpen(false);
              onBookSlot(program);
            }}
          >
            <Box>
              <Text color={"ms-red.900"} textStyle={"body1"}>
                {program === "cap" ? "Prepleaf Courses" : "Masai School Courses"}
              </Text>
              <Text color={"ms-grey.700"} textStyle={"caption"}>
                {program === "cap"
                  ? "includes Career Accelerater Program"
                  : "includes Web development, Data analytics"}
              </Text>
            </Box>
            <Box>
              <Button variant={"secondary"} size={isMobile ? "sm" : "md"}>
                Book A Slot
              </Button>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default NeedHelpModalContent;
